<ion-content class="validation-model-cnt">
  <ion-grid class="p-all-m h100">
    <div class="font-24-bold txt-align-c error-title">{{ 'emb_error_modal.errors' | translate }}</div>
    <div class="font-16-reg-l m-t-xs" *ngFor="let item of errors; let i = index">{{ i + 1 }}. {{ item }}</div>
    <ion-row class="m-t-xl bottom-buttons button-container">
      <button ion-button class="second-btn-sm font-16-sbold-80b" (click)="onOkClick()">
        {{ 'emb_error_modal.okay' | translate }}
      </button>
    </ion-row>
  </ion-grid>
</ion-content>
